import React from 'react';
import { useNavigate } from 'react-router-dom';
import PriceIcon from 'assets/icons/priceIcon.svg';
import Favourite from 'assets/icons/favourites-active.svg';
import Button from '../Button';

interface AssetCardProp {
  propertyId?: string;
  propertySlug: string;
  img: any;
  title: string;
  description: string;
  price?: string;
  favourite: boolean;
  address?: string;
}

const AssetCard = ({
  propertyId,
  propertySlug,
  img,
  title,
  description,
  price,
  favourite,
  address,
}: AssetCardProp) => {
  const navigate = useNavigate();

  return (
    <div className="relative rounded-3xl border border-bg-form mb-12">
      <div className="relative rounded-3xl border border-bg-form mb-12">
        {favourite && (
          <img
            src={Favourite}
            className="absolute top-4 right-4 cursor-pointer"
            alt=""
          />
        )}
        <img src={img} alt="" className="w-full" />
      </div>

      <div className="text-center py-6">
        <p className="text-white text-lg">{title}</p>

        <p className="text-white text-sm mt-2 mx-8 opacity-50">{description}</p>
        {address && (
          <p className="text-white text-sm mt-2 mx-8 opacity-50">{address}</p>
        )}
        {price && (
          <div className="flex justify-center mt-2">
            <img className="mr-1 mt-1" src={PriceIcon} alt="" />
            <p className="text-white">{price}</p>
          </div>
        )}

        <div className="flex justify-center mt-4">
          <Button
            type="button"
            variant="primary"
            onClick={() => navigate(`/property/${propertySlug}`)}
          >
            View More
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AssetCard;
